module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_kawaduzakura-81011200af4c4d79cc1571aefa808202.jpg";